export default function ClientName({ register, errors }) {
  const fieldName = "clientname";

  return (
    <div>
      <label className="wdc-field-label" htmlFor={fieldName}>
        Your name
      </label>
      <input
        id={fieldName}
        className="wdc-field"
        placeholder="Your full name"
        {...register(fieldName, { required: true })}
      />
      {errors[fieldName] && (
        <span className="wdc-error">This field is required</span>
      )}
    </div>
  );
}
